export default function Image(type,baseFilename,images,file=null){

    const fileLoadTime = new Date().getTime();

    return {
        type: type,
        baseFilename: baseFilename,
        images: images,
        file: file,
        key: baseFilename.concat(' ',fileLoadTime),
        url: images.file ? images.file : images.sm,
        isResponsive: images.length > 1 ? true : false,
        isLocal: (file !== null ? true : false)
    }
    
}




// export default function ImageFile(basename,url,file = null){
    
//     const fileLoadTime = new Date().getTime();

//     return{
//         basename: basename,
//         file: file,
//         filename: file ? file.name : null,
//         url: url,
//         key: basename.concat(' ',fileLoadTime),
//         isLocal: file ? true : false
//     }
    
// }

